

    export function insertCss (code) {
            var style = document.createElement('style');
            style.type = 'text/css';

            if (style.styleSheet) {
                // IE
                style.styleSheet.cssText = code;
            } else {
                // Other browsers
                style.innerHTML = code;
            }

            document.getElementsByTagName("head")[0].appendChild(style);
        }

/**
 * Transforma las traducciones del endpoint al formato i18n
 * @param {Array} translationsArray - Array de objetos con traducciones del backend
 * @returns {Object} Objeto con formato { es: {...}, en: {...}, pt: {...}, fr: {...} }
 */
export function transformTranslations(translationsArray) {
  if (!Array.isArray(translationsArray)) {
    console.warn('⚠️ translationsArray no es un array:', translationsArray);
    return {};
  }

  const result = {
    es: {},
    en: {},
    pt: {},
    fr: {},
    it: {},
    de: {},
    ca: {}
  };

  translationsArray.forEach(item => {
    // Usar el OriginalText tal cual como key (sin convertir a camelCase)
    const key = item.OriginalText.trim();

    // Asignar traducciones por idioma
    if (item.SpanishTranslation) result.es[key] = item.SpanishTranslation;
    if (item.EnglishTranslation) result.en[key] = item.EnglishTranslation;
    if (item.PortugueseTranslation) result.pt[key] = item.PortugueseTranslation;
    if (item.FrenchTranslation) result.fr[key] = item.FrenchTranslation;
    if (item.ItalianTranslation) result.it[key] = item.ItalianTranslation;
    if (item.GermanTranslation) result.de[key] = item.GermanTranslation;
    if (item.CatalanTranslation) result.ca[key] = item.CatalanTranslation;
  });

  console.log('✅ Traducciones transformadas:', result);
  return result;
}
